import React from "react";
import { IconPathProps } from "../../types";

export const ChevronDown = ({ lineColor, strokeWidth }: IconPathProps) => (
  <path
    d="M19.5 9L12 16.5L4.5 9"
    stroke={lineColor}
    strokeWidth={strokeWidth}
    strokeLinejoin="round"
  />
);
